import { CategoryImages } from './types';

const categories: Array<CategoryImages> = [
  {
    id: 'desserts',
    mainImage: '/images/nationalMenu/categories/CinnabonMiniRolls.jpg'
  },
  {
    id: 'dips',
    mainImage: '/images/nationalMenu/categories/Marinara.jpg'
  },
  {
    id: 'drinks',
    mainImage: '/images/nationalMenu/categories/Pepsi.jpg'
  },
  {
    id: 'pasta',
    mainImage: '/images/nationalMenu/categories/ChickenAlfredo.jpg'
  },
  {
    id: 'pizza',
    mainImage: '/images/nationalMenu/categories/PizzasPepLovers.jpg'
  },
  {
    id: 'sides',
    mainImage: '/images/nationalMenu/categories/Breadsticks.jpg'
  },
  {
    id: 'wings',
    mainImage: '/images/nationalMenu/categories/Wings.jpg'
  }
];

export default categories;
